import { render, staticRenderFns } from "./scopecenter5.vue?vue&type=template&id=12351ea2&scoped=true"
import script from "./scopecenter5.vue?vue&type=script&lang=js"
export * from "./scopecenter5.vue?vue&type=script&lang=js"
import style0 from "./scopecenter5.vue?vue&type=style&index=0&id=12351ea2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12351ea2",
  null
  
)

export default component.exports